module.exports = {
  siteMetadata: {
    name: 'Cloud Italia',
    hostname: 'cloud.italia.it',
    siteUrl: 'https://cloud.italia.it',
  },
  plugins: [
    'gatsby-plugin-sitemap',
    'gatsby-plugin-jss',
    'gatsby-plugin-react-helmet',
    {
      resolve: 'gatsby-source-filesystem',
      options: {
        name: 'contents',
        path: `${__dirname}/contents`,
      },
    },
    {
      resolve: 'gatsby-source-filesystem',
      options: {
        name: 'indeepStrategia',
        path: `${__dirname}/src/pages/strategia`,
      },
    },
    {
      resolve: 'gatsby-source-filesystem',
      options: {
        name: 'indeepAbilitazione',
        path: `${__dirname}/src/pages/abilitazione`,
      },
    },
    {
      resolve: 'gatsby-source-filesystem',
      options: {
        name: 'indeepQualificazione',
        path: `${__dirname}/src/pages/qualificazione`,
      },
    },
    {
      resolve: 'gatsby-transformer-remark',
      options: {
        plugins: [
          'gatsby-remark-attr',
          {
            resolve: `gatsby-remark-images`,
            options: {
              // It's important to specify the maxWidth (in pixels) of
              // the content container as this plugin uses this as the
              // base for generating different widths of each image.
              maxWidth: 740,
            },
          },
        ],
      },
    },
    'gatsby-plugin-image',
    'gatsby-plugin-sharp',
    'gatsby-transformer-sharp',
  ],
};
